import { createRouter, createWebHistory } from 'vue-router';
import { Bridge } from '@/utils/bridge';
import constants from '@/constants';
import { isAppEnv } from '@/utils/device';
import gateway from '@/router/modules/gateway';
import cart from '@/router/modules/cart.js';
import yourAccount from '@/router/modules/yourAccount';
import detailPage from '@/router/modules/detailPage';
import yourOrder from '@/router/modules/yourOrder';
import orderConfirm from '@/router/modules/orderConfirm.js';
import devPages from '@/router/modules/devPages';
import asinList from '@/router/modules/asinList';
import protocol from '@/router/modules/protocol';
const routes = [
  ...gateway,
  ...cart,
  ...yourAccount,
  ...detailPage,
  ...yourOrder,
  ...orderConfirm,
  ...devPages,
  ...protocol,
  ...asinList
];

const { TAB_BAR_ROUTER_NAME } = constants;

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export const isPrimaryPage = to => {
  let show = TAB_BAR_ROUTER_NAME.includes(to.name);
  // Cart independent judgment
  // If it is the root directory, display the bottom bar
  if (to.name === 'cart' && to.query?.rootPage) {
    show = true;
  }
  return show;
};

router.beforeEach((to, from, next) => {
  if (isAppEnv()) {
    const isPrimaryPageVal = isPrimaryPage(to);
    // Record the name and bottom bar status of the current route, It will be deleted in the future
    console.info('current router name>>>', to.name);
    console.info('current tabbar is isPrimaryPageVal>>>', isPrimaryPageVal);
    // To check whether the webview in login page or protocol pages which are redirected from login page privacy links
    if (Bridge.hasNativeMethodFn('asynJSCallNative')) {
      Bridge.callFnVal('controlWebViewGestures', {
        enable: !isPrimaryPageVal
      });
      Bridge.callFn(
        'bottomBarStatusChange',
        { show: isPrimaryPageVal },
        async () => {
          next();
        }
      );
    } else {
      next();
    }
  } else {
    next();
  }
});

router.onError(error => {
  console.log('router onError ==> ', error);
  if (/loading chunk \d* failed./i.test(error.message)) {
    window.location.reload();
  }
});

export default router;
